module.exports = __webpack_public_path__ + "static/img/42-北京第二实验小学(德胜校区).ee58197.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/42-北京第二实验小学(德胜校区).png
// module id = IhZd
// module chunks = 0